import React from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { Avatar, ListItemAvatar, Grid } from '@mui/material';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import './ConstSizeList.scss';

function ConstSizeList({ items, onDelete }) {
  return (
    <List sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {items.map((i) => (
        <ListItem
          divider
          key={i.key}
          disableGutters
          secondaryAction={
            <IconButton edge="end" aria-label="delete" onClick={onDelete(i)}>
              <DeleteIcon />
            </IconButton>
          }>
          <Grid container>
            <ListItemAvatar>
              <Avatar>
                <AspectRatioIcon />
              </Avatar>
            </ListItemAvatar>
            <Grid item xs={12} md={3}>
              <ListItemText primary={i.size} secondary={`$${i.cost}`} />
            </Grid>
            <Grid item xs={12} md={3}>
              <ListItemText xs={5} primary={i.industry} />
            </Grid>
            <Grid item xs={12} md={3}>
              <p style={{ color: '#0997BA', fontWeight: 'bold' }}>
                {i.space_number} {i.space_number > 1 ? 'Spaces Available' : 'Space Available'}
              </p>
            </Grid>
          </Grid>
        </ListItem>
      ))}
    </List>
  );
}

ConstSizeList.propTypes = {
  onDelete: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      cost: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default ConstSizeList;
